export const baseURL=`https://smooth-picks.duckdns.org/api`;
export const REGISTER=`register`;
export const LOGIN=`login`;

export const USERS='users';
export const USER='user';

export const CAT='categories';
export const Cate='category';

export const PRO='products';
export const Pro='product';

export const LatestSALE='latest-sale';
export const Latest='latest';
export const TopRatedApi='top-rated';

export const LOGOUT='logout';

export const GOOGLE_CALL_BACK='auth/google/callback';